<div class="o-grid" style="position:relative" *ngIf="vm.chats && vm.chats.length > vm.limit">
	<div class="c-dropdown c-dropdown--top c-dropdown--right">
		<button class="c-dropdown__toggle c-button c-button--s1">
			<i class="o-icon o-icon--chat" aria-hidden="true"></i> {{ vm.chats?.length - vm.limit }}
		</button>
		<ul class="c-dropdown__menu c-list c-list--s1">
			<ng-container *ngFor="let chat of vm.chats ; let $index=index">
				<li class="c-list__item" *ngIf="$index >= vm.limit">
					<div class="o-grid o-grid--center-v">
						<div class="o-grid__cell u-no-p">
							<a class="c-list__link" (click)="vm.openChat(chat)">{{chat.privateChatFriend.firstname + " " + chat.privateChatFriend.lastname}}</a>
						</div>
						<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
							<button class="c-button c-button--icon c-button--s7" (click)="vm.removeChat(chat)">
								<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
								<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
							</button>
						</div>
					</div>
				</li>
			</ng-container>
		</ul>
	</div>
</div>
